/** "request_not_actioned" → "Request not actioned". */
export function failureTypeLabel(type: string | null): string {
  if (!type) return 'No type';
  const words = type.replace(/_/g, ' ');
  return `${words[0].toUpperCase()}${words.slice(1)}`;
}

/** The types the regression gate treats as serious (see FAILURE_TYPES). */
const SERIOUS = new Set([
  'wrong_claim',
  'request_not_actioned',
  'promise_without_handoff',
]);
export const isSeriousType = (type: string | null) =>
  !!type && SERIOUS.has(type);

/** "24 Oct, 09:00" in UK time. */
export function shortDateTime(iso: string): string {
  return new Date(iso).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/London',
  });
}

export const harnessUrl = (conversationId: string) =>
  `/admin/harness?conversationId=${encodeURIComponent(conversationId)}`;

/** The one failure type every selected reply shares, if they share one. */
export function commonType(types: (string | null)[]): string | null {
  const set = new Set(types);
  return set.size === 1 ? ([...set][0] ?? null) : null;
}

/** A shell word, safe whatever the staff typed. */
const shellQuote = (value: string) => `'${value.replace(/'/g, `'\\''`)}'`;

/**
 * The command that starts the Claire fix agent (claire-fix.yml) on a group.
 * Staff-written text only: the workflow reads the cases from the pack.
 */
export function fixAgentCommand(group: {
  id: string;
  title: string;
  description: string;
  failureType: string | null;
  members: { observationId: string }[];
}): string {
  const fields: [string, string][] = [
    ['group_id', group.id],
    ['title', group.title],
    ['observations', group.members.map((m) => m.observationId).join(',')],
  ];
  if (group.description.trim()) fields.push(['description', group.description]);
  if (group.failureType) fields.push(['failure_type', group.failureType]);
  return [
    'gh workflow run claire-fix.yml --repo Borradh-Media/borradh-workspace',
    ...fields.map(([k, v]) => `  -f ${k}=${shellQuote(v)}`),
  ].join(' \\\n');
}

export const FIX_AGENT_RUNS_URL =
  'https://github.com/Borradh-Media/borradh-workspace/actions/workflows/claire-fix.yml';
